<p-dialog
  [modal]="true"
  [(visible)]="visible"
  (onHide)="onHide()"
  [style]="{ width: '560px' }"
>
  <!-- Header -->

  <ng-template pTemplate="header">
    <div class="flex items-center gap-2">
      <div
        class="flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-primary-500"
      >
        <lucide-icon
          name="chartNoAxesCombined"
          class="text-primary-600"
          [size]="20"
        ></lucide-icon>
      </div>
      <span class="text-xl font-semibold text-greyscale-900">
        {{
          mode === "create"
            ? ("factorPage.dialogTitleCreate" | transloco)
            : ("factorPage.dialogTitleEdit" | transloco)
        }}
      </span>
    </div>
  </ng-template>

  <!-- Form -->
  <form class="mb-4 flex w-full flex-col gap-4" [formGroup]="factorForm">
    <!-- Name -->
    <div class="flex flex-col items-start">
      <label for="factor-name" class="text-paragraph-xs-med text-greyscale-700">
        {{ "factorPage.dialog.name" | transloco }} *
      </label>
      <input
        pInputText
        id="factor-name"
        formControlName="name"
        [fluid]="true"
      />
      <app-error [control]="factorForm.get('name')!" />
    </div>

    <!-- Source -->
    <div class="flex flex-col gap-2">
      <div class="flex flex-col items-start">
        <div class="flex items-center gap-1">
          <label
            for="factor-source"
            class="flex items-center gap-1 text-paragraph-xs-med text-greyscale-700"
          >
            {{ "factorPage.dialog.source" | transloco }} *
          </label>
          <app-tooltip-icon
            [message]="'factorPage.dialog.sourceTooltip' | transloco"
            position="right"
          />
        </div>

        <input
          pInputText
          id="factor-source"
          formControlName="source"
          [fluid]="true"
        />
        <app-error [control]="factorForm.get('source')!" />
      </div>
      <!-- Warning -->
      <div
        class="flex items-start gap-2 rounded-lg border border-warning-200 bg-warning-50 p-2"
      >
        <lucide-icon
          name="triangle-alert"
          class="mt-0.5 shrink-0 text-warning-600"
          [size]="16"
        ></lucide-icon>
        <p class="text-paragraph-xs-reg text-warning-800">
          {{ "factorPage.warning" | transloco }}
        </p>
      </div>
    </div>

    <!-- Category -->
    <div class="flex flex-col items-start">
      <label
        for="factor-category"
        class="text-paragraph-xs-med text-greyscale-700"
      >
        {{ "factorPage.dialog.category.label" | transloco }} *
      </label>
      <p-dropdown
        id="factor-category"
        [options]="categoryOptions"
        optionLabel="label"
        optionValue="value"
        formControlName="category"
        [fluid]="true"
        [placeholder]="'factorPage.dialog.category.placeholder' | transloco"
        class="w-full"
      />
      <app-error [control]="factorForm.get('category')!" />
    </div>

    @if (isAccommodation) {
      <!-- Accommodation: valuePerNight -->
      <div class="flex flex-col items-start">
        <label
          for="factor-value-night"
          class="text-paragraph-xs-med text-greyscale-700"
        >
          {{ "calculator.factor.valuePerNight" | transloco }}
        </label>
        <p-inputNumber
          id="factor-value-night"
          formControlName="valuePerNight"
          [fluid]="true"
          [minFractionDigits]="0"
          [maxFractionDigits]="10"
        />
        <app-error [control]="factorForm.get('valuePerNight')!" />
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        <!-- Calculation hint -->
        <!-- <div
          class="flex items-start gap-2 rounded-lg border border-primary-200 bg-primary-50 p-2"
        >
          <lucide-icon
            name="info"
            class="mt-0.5 shrink-0 text-primary-600"
            [size]="16"
          ></lucide-icon>
          <p class="whitespace-pre-line text-paragraph-xs-reg text-primary-700">
            {{ "factorPage.dialog.calculationHint" | transloco }}
          </p>
        </div> -->
        <!-- Other categories: valuePerKm, valuePerH, speed -->
        <div class="flex flex-col gap-4 md:flex-row">
          <div class="flex flex-1 flex-col items-start">
            <div class="flex items-center gap-1">
              <label
                for="factor-value-km"
                class="text-paragraph-xs-med text-greyscale-700"
              >
                {{ "factorPage.dialog.valuePerKm" | transloco }}
              </label>
              <app-tooltip-icon
                [message]="'factorPage.dialog.valuePerKmTooltip' | transloco"
                position="right"
              />
            </div>
            <p-inputNumber
              id="factor-value-km"
              formControlName="valuePerKm"
              [fluid]="true"
              [minFractionDigits]="0"
              [maxFractionDigits]="10"
            />
            <app-error [control]="factorForm.get('valuePerKm')!" />
          </div>

          <div class="flex flex-1 flex-col items-start">
            <div class="flex items-center gap-1">
              <label
                for="factor-value-h"
                class="text-paragraph-xs-med text-greyscale-700"
              >
                {{ "factorPage.dialog.valuePerH" | transloco }}
              </label>
              <app-tooltip-icon
                [message]="'factorPage.dialog.valuePerHTooltip' | transloco"
                position="right"
              />
            </div>
            <p-inputNumber
              id="factor-value-h"
              formControlName="valuePerH"
              [fluid]="true"
              [minFractionDigits]="0"
              [maxFractionDigits]="10"
            />
            <app-error [control]="factorForm.get('valuePerH')!" />
          </div>
        </div>
<!-- Speed -->
        <!-- <div class="flex flex-col items-start">
          <label
            for="factor-speed"
            class="text-paragraph-xs-med text-greyscale-700"
          >
            {{ "factorPage.dialog.speed" | transloco }}
          </label>
          <p-inputNumber
            id="factor-speed"
            formControlName="speed"
            [fluid]="true"
          />
        </div> -->
      </div>
    }

    <!-- Uncertainty -->
    <div class="flex flex-col items-start">
      <label for="uncertainty" class="text-paragraph-xs-med text-greyscale-700">
        {{ "factorPage.dialog.uncertainty" | transloco }}
        <a
          [href]="uncertaintyUrl"
          target="_blank"
          class="ml-1 text-xs text-primary-600 underline"
        >
          {{ "factorPage.dialog.uncertaintyLearnMore" | transloco }}
        </a>
      </label>
      <p-inputNumber
        id="uncertainty"
        formControlName="uncertainty"
        [fluid]="true"
        [min]="0"
        [max]="100"
        [suffix]="' %'"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
      />
      <app-error [control]="factorForm.get('uncertainty')!" />
    </div>
  </form>

  <!-- Footer -->
  <div class="flex w-full items-end justify-end gap-4">
    <p-button
      [label]="'close' | transloco"
      (click)="closeDialog()"
      severity="secondary"
      [text]="true"
    />
    <p-button
      [label]="(mode === 'create' ? 'create' : 'save') | transloco"
      (click)="submit()"
      [loading]="loading"
      [disabled]="factorForm.invalid"
    />
  </div>
</p-dialog>
